import { getCustomer } from "../../../../../util/user";

export const initialState = {
  customer: getCustomer(),
  filters: {},
  selectedFiltersArr: [],
  selectedFiltersArrByFilterKey: {},
  selectedFiltersMap: {},
  reportsAggs: [],
	isLoading: false,
	isLoaded: false,
	errorMessage: undefined
};

export default initialState;
